import React from "react";
import { BsTwitter } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
import { BsTelegram } from "react-icons/bs";
import { BsFacebook } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { CgMail } from "react-icons/cg";
import { BsYoutube } from "react-icons/bs";

function Footer() {
  return (
    <div className="border-t-2 border-[#EA6F0B]">
      <div className="flex justify-between flex-wrap  mx-auto pt-[50px]">
        <div className="cursor-pointer  max-w-[150px] ">
          <a href="/#">
            <img
              src={process.env.PUBLIC_URL + "assets/images/logo1.png"}
              width="75%"
            ></img>
          </a>
        </div>
        <div className="flex justify-center  items-center">
          <div className="justify-center md:flex flex-wrap  gap-4 text-[18px] ">
            <span>
              <a href="#tokenomics">Tokenomics</a>
            </span>
            <span>
              <a href="#security">Security</a>
            </span>
            <span>
              <a href="#ecosystem">Ecosystem</a>
            </span>
            <span>
              <a href="#roadmap">Roadmap</a>
            </span>
            {/* <span>
              <a href="/about">AboutUs</a>
            </span> */}
          </div>
        </div>

        <div className="flex justify-center  items-center mr-0 md:mr-[2rem]">
          <div className="flex gap-4  cursor-pointer">
            <a href="https://twitter.com/">
              <BsTwitter style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
            <a href="https://www.youtube.com/channel/UCcQosPtqAYSdhvro_0eMehw">
              < BsYoutube style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
            <a href="http://discordapp.com/users/1053735494242025595">
              <FaDiscord style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
            <a href="http://t.me/metaranpo11">
              <BsTelegram style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100089037518319">
              <BsFacebook style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
            <a href="https://www.instagram.com/meta_ranpo/">
              < BsInstagram style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
            <a href=" mailto:mailmetaranpo@gmail.com">
              < CgMail style={{ fontSize: "2em", color: "#EA6F0B" }} />
            </a>
          </div>
        </div>
      </div>
      <div className="pb-[2rem] ">
        <h4 className="ml-0 md:mr-[10rem]">
          © 2022 Project Meta Ranpo. All rights reserved
        </h4>
      </div>
    </div>
  );
}

// const SocialLinksData = [
//   {
//     link: "/",
//     name: "Discord",
//     path: process.env.PUBLIC_URL + "assets/images/discord.svg",
//   },
//   {
//     link: "/",
//     name: "Twitter",
//     path: process.env.PUBLIC_URL + "assets/images/twitter.svg",
//   },
//   {
//     link: "/",
//     name: "Telegram",
//     path: process.env.PUBLIC_URL + "assets/images/telegram.svg",
//   },
// ];

export default Footer;
